export type DetailsRow = { label: string; value: string }

// Parses the detail-column contract: a JSON array of {label, value} objects,
// both strings, which a receptor can emit in place of several sparse columns.
// Returns null for anything else so callers fall back to plain-text rendering.
export const parseDetailsRows = (raw?: string): DetailsRow[] | null => {
  if (!raw) {
    return null
  }
  try {
    const parsed: unknown = JSON.parse(raw)
    if (
      !Array.isArray(parsed) ||
      parsed.length === 0 ||
      !parsed.every(
        (row): row is DetailsRow =>
          typeof row === 'object' &&
          row !== null &&
          typeof (row as DetailsRow).label === 'string' &&
          typeof (row as DetailsRow).value === 'string',
      )
    ) {
      return null
    }
    return parsed
  } catch {
    return null
  }
}

// The one-line form a details cell shows ("Region: us-east-1 | Owner: ops").
export const detailsPreview = (rows: DetailsRow[]): string =>
  rows.map((row) => `${row.label}: ${row.value}`).join(' | ')

// A cell value as the grid shows it: a details payload becomes its preview, anything
// else is shown as is. Search uses this so it matches what's on screen.
export const cellDisplayText = <T>(value: T): T | string => {
  if (typeof value !== 'string') {
    return value
  }
  const rows = parseDetailsRows(value)
  return rows ? detailsPreview(rows) : value
}
